import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./components/Shared/index";
import VueCookies from 'vue-cookies';
import VueAnalytics from 'vue-analytics';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faChevronDown,faChevronUp, faAngleDoubleRight,faAngleDoubleLeft, faCaretLeft, faPlus,faTimes, faArrowsAlt, faBackspace, faArrowDown} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faChevronDown,faChevronUp, faAngleDoubleRight, faAngleDoubleLeft, faCaretLeft, faPlus, faTimes, faArrowsAlt, faBackspace, faArrowDown)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.prototype.$isMobile = function(): boolean {
  return window.orientation !== undefined;

}
Vue.use(VueCookies);
Vue.$cookies.config('1y');

if (Vue.$cookies.get("cookiesConsent")) {
  Vue.use(VueAnalytics, {
    id: 'UA-156068488-1',
    router
  });
}

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
